import styled from "styled-components";
import {Container, Text1, Title1} from "../../../../styles/business-components";

export const CustomContainer = styled(Container)`
  margin-top: 40px;
`

export const Content = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 40px;
`

export const SmallContent = styled.div`
  position: relative;
  width: 100%;
  height: 450px;
`

export const Title = styled(Title1)`
  white-space: pre;
`

export const Text = styled(Text1)`
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 18px;
    line-height: 40px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 24px;
    line-height: 60px;
    margin-bottom: 20px;
  }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media only screen and (${({theme}) => theme.media.large}) {
    gap: 20px;
  }
`

export const ImageBlock = styled.div`
  position: relative;
  width: 100%;

  @media only screen and (${({theme}) => theme.media.large}) {
    width: 65%;
  }
`

export const Image = styled.img`
  width: 100%;
`

export const Card = styled.div`
  position: absolute;
  bottom: -150px;
  right: 0;
  width: 50%;
  padding: 30px;
  border-radius: 40px;
  background-color: ${({theme}) => theme.business.colors.cardBackground3};
`

export const SmallCard = styled.div`
  position: absolute;
  top: 80%;
  right: 0;
  left: 0;
  margin-right: auto;
  margin-left: auto;
  width: 95%;
  padding: 10px;
  border-radius: 20px;
  background-color: ${({theme}) => theme.business.colors.cardBackground3};
`